import React from "react"
import { Container } from "./RelatedPages.styles"
import { Link } from "gatsby"

const RelatedPages = pages => {
  const data = pages.pages

  const pageLinks = data.map(page => (
    <li className="rightLink" key={page.slug}>
      <Link to={`/${page.slug}`}>{page.title}</Link>
    </li>
  ))

  return (
    <>
      <Container>
        <div className="containerTop">
          <h3 className="primaryLabel whiteTxt">Related Pages</h3>
        </div>
        <div className="containerBottom">
          <ul>{pageLinks}</ul>
        </div>
      </Container>
    </>
  )
}

export default RelatedPages
